import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { AllCompaniesTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<AllCompaniesTheme>;
const css = baseCss as ThemedCssFunction<AllCompaniesTheme>;

export const AllCompanies = styled.div`
width: 100%;
height: 100%
`;
